import {culturalAlignmentColors} from '../../components/WorkforceProfileDetail/WorkforceProfileDetail.colors';
import type {WorkforceAlignmentLabel} from '../../types/WorkforceProfileTypes';


export const COMPANY_MARKER_COLOR = culturalAlignmentColors.companyMarker;
export const PROFILE_MARKER_COLOR = culturalAlignmentColors.profileMarker;

export const scaleValueToPercent = (value: number, minValue: number, maxValue: number): number => {
  if (maxValue <= minValue) {
    return 0;
  }

  return ((value - minValue) / (maxValue - minValue)) * 100;
};

export const resolveOverlapPercent = (overlap: number | null | undefined): number => {
  if (overlap == null || Number.isNaN(overlap)) {
    return 0;
  }

  return overlap <= 1 ? Math.round(overlap * 100) : Math.round(overlap);
};

export const getAlignmentBadgeColors = (overlapLabel: WorkforceAlignmentLabel): {color: string; bgcolor: string} =>
  culturalAlignmentColors.badge[overlapLabel];
